export enum EWorkOrderStatus {
  Draft,
  Scheduled,
  Complete,
  Archived,
}
